import React, {FC, PropsWithChildren} from 'react';

import {cn} from '@bem-react/classname';
import useHeightPostMessage from 'ui/hooks/useHeightPostMessage';

import Footer from '../Footer';
import Header from '../Header';

import './PreviewLayout.scss';

const cnPreviewLayout = cn('PreviewLayout');

const PreviewLayout: FC<PropsWithChildren<{}>> = ({children}) => {
    const ref = useHeightPostMessage();
    return (
        <div className={cnPreviewLayout()} ref={ref}>
            <Header />
            <div className={cnPreviewLayout('Content')}>{children}</div>
            <Footer />
        </div>
    );
};

export default PreviewLayout;
